import { render, staticRenderFns } from "./CmsFieldsCategorySelector.vue?vue&type=template&id=f48156b2&scoped=true"
import script from "./CmsFieldsCategorySelector.vue?vue&type=script&lang=ts"
export * from "./CmsFieldsCategorySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48156b2",
  null
  
)

export default component.exports